module.exports = __webpack_public_path__ + "img/9.5a32eea7.jpg";